import { useEffect, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { useLocation } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas';

import Box from '../../components/layout/Box';
import MenuContent from '../LeftNavbar/MenuContent';
import MenuHeader from '../LeftNavbar/MenuHeader';
import Icon from '../../components/Icon';

const StyledBox = styled(Box)`
  display: flex;
  padding-left: 8px;
  padding-right: 8px;

  @media (min-width: 769px) {
    display: none;
  }
`;

const MobileMenu = () => {
  const theme = useTheme();

  const { lightBlackColor } = theme.colors;

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const location = useLocation();

  useEffect(() => {
    handleClose();
  }, [location]);

  return (
    <StyledBox>
      <Box onClick={handleShow}>
        <Icon name="menu-outline" size={32} color={lightBlackColor} />
      </Box>

      <Offcanvas
        show={show}
        onHide={handleClose}
        style={{ background: '#0a65cd', height: '100%' }}
      >
        <Offcanvas.Header
          closeButton
          closeVariant="white"
          style={{ paddingRight: 24 }}
        >
          <MenuHeader isOpen />
        </Offcanvas.Header>
        <Offcanvas.Body
          style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}
        >
          <MenuContent isMobile handleClose={handleClose} />
        </Offcanvas.Body>
      </Offcanvas>
    </StyledBox>
  );
};

export default MobileMenu;
